import React, { FC, useContext, useMemo } from 'react';

import {
  H3,
  IDropdownItem,
  ISelectOption,
  Select,
  Separator,
} from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, ICurrency, SettingsContext } from 'settings';

import s from './Currency.module.scss';

export const Currency: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings, isLoading, currencies },
    actions: { setSetting },
  } = useContext(SettingsContext);

  const CURRENCIES_OPTIONS = useMemo(
    () =>
      currencies.map<ISelectOption<string, ICurrency>>((currency) => ({
        value: currency.alias,
        title: currency.title,
        original: currency,
      })),
    [currencies]
  );

  return (
    <>
      <H3>{t('setting.currency')}</H3>
      <span className={s.subtitle}>
        {t('settings.billing.vote.currency.description')}
      </span>
      <Separator style={{ margin: '16px 0' }} />
      <Select
        name="club_currency"
        value={settings.currency.value}
        onChange={(value) => {
          if (!value) return;

          return setSetting({
            alias: ESettingsAliases.CURRENCY,
            value,
          });
        }}
        options={CURRENCIES_OPTIONS}
        disabled={isLoading}
        renderOption={(item: IDropdownItem<string, ICurrency>) => (
          <span>
            {item.original?.letter}
            <span style={{ color: 'var(--text-secondary)' }}>
              {' '}
              — {item.title}
            </span>
          </span>
        )}
        placeholder={t('setting.currency')}
        disableClear
        bordered
      />
    </>
  );
};
